// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M13 7.5V12C13 13.1 12.1 14 11 14H5C3.9 14 3 13.1 3 12V7.5',
  'M8 10.25V1.75M5.04 4.71L8 1.75L10.96 4.71',
];
